import React, { useState, useEffect } from 'react';
import CategoryCard from '../components/CategoryCard';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiService } from '../services/api';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await apiService.getCategories();
        setCategories(response.data?.main_categories || []);
      } catch (err) {
        console.error('Kategoriler yüklenirken hata:', err);
        setError('Kategoriler yüklenirken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return <LoadingSpinner message="Kategoriler yükleniyor..." />;
  }

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="display-5 fw-bold mb-4">Kategoriler</h1>
          <p className="lead text-muted mb-5">
            Geniş ürün yelpazemizden size uygun kategoriyi seçin
          </p>

          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          {categories.length > 0 ? (
            <div className="row">
              {categories.map((category) => (
                <div key={category.id} className="col-lg-4 col-md-6 mb-4">
                  <CategoryCard category={category} />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <i className="bi bi-tags display-1 text-muted mb-3"></i>
              <h3>Kategori Bulunamadı</h3>
              <p className="text-muted">Henüz kategori eklenmemiş.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Categories;
